// extracted by mini-css-extract-plugin
export default {"homeBannerVideo":"homeVideoBaneer_homeBannerVideo__kCH4k"};